// Education-level display helpers for CSP standard sets.
//
// Order ported verbatim from the Common Standards Project (models/standard_set.rb
// EDUCATION_LEVELS); friendly labels cleaned up for K-12 from the CSP importer's
// assign_title transformer.

export const EDUCATION_LEVEL_ORDER = [
  'Pre-K',
  'K',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  'VocationalTraining',
  'ProfessionalEducation-Development',
  'Graduate',
  'HigherEducation',
  'Undergraduate-UpperDivision',
  'Undergraduate-LowerDivision',
  'AdultEducation',
  'LifeLongLearning',
] as const;

const EDUCATION_LEVEL_LABELS: Record<string, string> = {
  'Pre-K': 'Pre-K',
  K: 'Kindergarten',
  VocationalTraining: 'Vocational Training',
  'ProfessionalEducation-Development': 'Professional Education & Further Development',
  Graduate: 'Graduate',
  HigherEducation: 'Higher Education',
  'Undergraduate-UpperDivision': 'Four Year College',
  'Undergraduate-LowerDivision': 'Two Year College',
  AdultEducation: 'Adult Education',
  LifeLongLearning: 'Life-long Learning',
};

const ORDER_INDEX = new Map<string, number>(
  EDUCATION_LEVEL_ORDER.map((code, index) => [code, index])
);

/** Map a CSP education-level code to a human label (e.g. "06" → "Grade 6", "K" → "Kindergarten"). */
export function formatEducationLevel(code: string): string {
  const trimmed = code.trim();
  if (EDUCATION_LEVEL_LABELS[trimmed]) return EDUCATION_LEVEL_LABELS[trimmed];
  if (/^\d+$/.test(trimmed)) return `Grade ${Number(trimmed)}`;
  return trimmed;
}

/** Sort education-level codes by the CSP canonical order; unknown codes sort last, alphabetically. */
export function sortEducationLevels(codes: string[]): string[] {
  return [...codes].sort((a, b) => {
    const ia = ORDER_INDEX.get(a) ?? Number.MAX_SAFE_INTEGER;
    const ib = ORDER_INDEX.get(b) ?? Number.MAX_SAFE_INTEGER;
    return ia !== ib ? ia - ib : a.localeCompare(b);
  });
}
